import * as STORAGE from '@/constants/STORAGE';

import { apiSetToken } from '@/services/api-recebimentoweb';

import storage from '@/services/storage';

export default {
  namespaced: true,

  state: {
    accessToken: null,
    user: null,
  },

  getters: {
    accessToken: (state) => state.accessToken,
    user: (state) => state.user,
  },

  actions: {
    async $_setup({ dispatch, commit }) {
    const accessToken = await storage.getItem(STORAGE.TOKEN);

    if (!accessToken) {
      if (process.env.VUE_APP_CHAVE_EMPRESA) {
        apiSetToken(null);
      }
      return; 
    }

      commit('SET_TOKEN', accessToken);

      await new Promise((resolve) => setTimeout(resolve, 100));
      await dispatch('loadUser');
    },

    async authenticate({ commit, dispatch }, payload) {
      const accessToken = await dispatch('vendedor/login', payload, { root: true });

      await storage.setItem(STORAGE.TOKEN, accessToken);
      commit('SET_TOKEN', accessToken);

      await new Promise((resolve) => setTimeout(resolve, 100));
      await dispatch('loadUser');
    },

    async authenticateLocal() {
      const accessToken = { token: 'f60a4a79-37bf-44b3-a661-ce18eb83e6e1' };

      await storage.setItem(STORAGE.TOKENLOCAL.tokenlocal, accessToken);
    },

    async unauthenticate({ commit }) {
      // dispatch('users/logout', null, { root: true })
      //   .catch();

      await storage.removeItem(STORAGE.TOKEN);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    },

    async loadUser({ commit }) {
      const user = {
        vennome: 'USUARIO',
        venchave: '@555',
      };
      commit('SET_USER', user);
    },

    // unauthenticate customizado
    async logout({ commit }) {
      await storage.removeItem(STORAGE.TOKEN);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    },

  },

  mutations: {
    SET_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      apiSetToken(accessToken?.token);
    },

    SET_USER(state, user) {
      state.user = user;
    },
  },
};
